// City data for /lokalt/:city local SEO landing pages.
// Names use correct Swedish diacritics; slugs are ASCII for clean URLs.

export const CITIES = {
  stockholm: {
    slug: "stockholm",
    name: "Stockholm",
    region: "Stockholms län",
    blurb:
      "Stockholm är en av Sveriges mest hundtäta städer — med tusentals hundar i Vasastan, Södermalm, Östermalm och Bromma som dagligen behöver dagis, pensionat eller hundvakter.",
    activeBusinesses: "120+",
    neighborhoods: ["Vasastan", "Södermalm", "Östermalm", "Bromma", "Hammarby Sjöstad"],
    testimonial: {
      name: "Maria Lindqvist",
      role: "Ägare",
      business: "Tassträff Hundpensionat",
      area: "Bromma, Stockholm",
      quote:
        "Vi driver hundpensionat i Stockholm sedan 2012. Sedan vi bytte till Hundify har vi sparat 18 timmar i veckan på admin — och den digitala check-in:en är en wow-faktor för våra Stockholmskunder.",
      rating: 5,
      initial: "M",
    },
  },
  goteborg: {
    slug: "goteborg",
    name: "Göteborg",
    region: "Västra Götaland",
    blurb:
      "Hundverksamheter i Göteborg — från Majorna till Hisingen och Mölndal — letar i allt högre grad efter ett digitalt affärssystem som faktiskt fungerar lika bra på land som vid kusten.",
    activeBusinesses: "80+",
    neighborhoods: ["Majorna", "Hisingen", "Mölndal", "Frölunda", "Lindholmen"],
    testimonial: {
      name: "Jonas Eriksson",
      role: "VD",
      business: "Vovvevillan Hunddagis",
      area: "Majorna, Göteborg",
      quote:
        "Som hunddagis i Göteborg har vi länge letat efter ett affärssystem som hanterar både bokningar, fakturor och kundkommunikation utan tre olika appar. Hundify levererar — och kundsupporten svarar på svenska.",
      rating: 5,
      initial: "J",
    },
  },
  malmo: {
    slug: "malmo",
    name: "Malmö",
    region: "Skåne",
    blurb:
      "I Malmö och Öresundsregionen växer hunddagis och pensionat snabbt. Många jobbar med både svenska och danska kunder — vilket ställer nya krav på flexibla affärssystem.",
    activeBusinesses: "60+",
    neighborhoods: ["Limhamn", "Västra Hamnen", "Hyllie", "Möllevången", "Lund"],
    testimonial: {
      name: "Lina Pettersson",
      role: "Ägare",
      business: "Skånepatrullen Hunddagis",
      area: "Limhamn, Malmö",
      quote:
        "Bokningssystem, fakturor och ägar-app — allt på svenska och perfekt för oss som driver hunddagis i Malmö. Våra kunder älskar bildflödet, och vi älskar att fakturorna går ut automatiskt.",
      rating: 5,
      initial: "L",
    },
  },
  uppsala: {
    slug: "uppsala",
    name: "Uppsala",
    region: "Uppsala län",
    blurb:
      "Uppsalas hundverksamheter behöver hantera en blandning av studenter, akademiker och barnfamiljer — kunder som förväntar sig modern teknik och tydlig kommunikation.",
    activeBusinesses: "40+",
    neighborhoods: ["Centrum", "Luthagen", "Sunnersta", "Gränby", "Bälinge"],
    testimonial: {
      name: "Anders Bergström",
      role: "Grundare",
      business: "Uppsala Hundhotell",
      area: "Gränby, Uppsala",
      quote:
        "Vi driver Uppsalas största hundpensionat med 40 rum. Sedan vi bytte till Hundifys affärssystem har vi noll överbokningar och betydligt nöjdare personal — pappersarbetet är borta.",
      rating: 5,
      initial: "A",
    },
  },
  vasteras: {
    slug: "vasteras",
    name: "Västerås",
    region: "Västmanland",
    blurb:
      "Hundverksamheter i Västerås och Mälardalen drar nytta av närheten till både Stockholm och Örebro — och behöver ett affärssystem som klarar geografisk flexibilitet.",
    activeBusinesses: "25+",
    neighborhoods: ["Centrum", "Skiljebo", "Vallby", "Bjurhovda", "Hökåsen"],
    testimonial: {
      name: "Petra Holm",
      role: "Ägare",
      business: "Mälardalens Hunddagis",
      area: "Vallby, Västerås",
      quote:
        "Hundify fungerar lika bra som affärssystem för vårt hunddagis i Västerås som det skulle göra i Stockholm. Att kunna boka av-och-på platser via ägar-appen sparar oss flera timmar varje vecka.",
      rating: 5,
      initial: "P",
    },
  },
  orebro: {
    slug: "orebro",
    name: "Örebro",
    region: "Närke",
    blurb:
      "Örebro växer som hund-stad. Hundrastare och hunddagis i regionen behöver effektiva schemaverktyg och GPS-spårning för att hålla servicenivån hög.",
    activeBusinesses: "20+",
    neighborhoods: ["Centrum", "Almby", "Adolfsberg", "Hovsta", "Marieberg"],
    testimonial: {
      name: "Henrik Strand",
      role: "VD",
      business: "Närkes Hundvänner",
      area: "Adolfsberg, Örebro",
      quote:
        "Vi rastar 80 hundar i veckan runt Örebro. GPS-spårningen i Hundify ger våra kunder den trygghet de förväntar sig — och våra hundvakter slipper jobba i tre olika appar samtidigt.",
      rating: 5,
      initial: "H",
    },
  },
  linkoping: {
    slug: "linkoping",
    name: "Linköping",
    region: "Östergötland",
    blurb:
      "I Linköping och Östergötland efterfrågar moderna hundverksamheter ett affärssystem som skalar — från ett enmans-dagis till regionens största hundpensionat.",
    activeBusinesses: "18+",
    neighborhoods: ["Centrum", "Berga", "Vasastaden", "Ryd", "Lambohov"],
    testimonial: {
      name: "Cecilia Norén",
      role: "Grundare",
      business: "Östgöta Hundtjänst",
      area: "Berga, Linköping",
      quote:
        "Som Linköpings ledande hundverksamhet behövde vi ett modernt system som klarar både dagis, pensionat och promenader. Hundify var rätt val från dag ett — vi hade igång det inom en vecka.",
      rating: 5,
      initial: "C",
    },
  },
  helsingborg: {
    slug: "helsingborg",
    name: "Helsingborg",
    region: "Skåne",
    blurb:
      "Helsingborgs hundpensionat och dagis tar emot gäster från både Sverige och Danmark. Det ställer krav på flerspråkig kommunikation och flexibel fakturering.",
    activeBusinesses: "15+",
    neighborhoods: ["Centrum", "Råå", "Maria Park", "Dalhem", "Ödåkra"],
    testimonial: {
      name: "Markus Lundgren",
      role: "Ägare",
      business: "Sundets Hundhotell",
      area: "Råå, Helsingborg",
      quote:
        "Vi har gäster från både Sverige och Danmark här i Helsingborg. Hundifys flerspråkiga ägar-app gör vardagen smidig, och vi kan skicka fakturor i SEK eller DKK utan att tänka på det.",
      rating: 5,
      initial: "M",
    },
  },
};

export const TOP_CITIES = ["stockholm", "goteborg", "malmo", "uppsala"];

export const ALL_CITY_SLUGS = Object.keys(CITIES);

function prettyCapitalize(raw) {
  const decoded = decodeURIComponent(raw || "").trim();
  if (!decoded) return "";
  return decoded
    .split(/[-\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toLocaleUpperCase("sv-SE") + w.slice(1).toLocaleLowerCase("sv-SE"))
    .join(" ");
}

const SLUG_ALIASES = {
  "göteborg": "goteborg",
  "malmö": "malmo",
  "västerås": "vasteras",
  "örebro": "orebro",
  "linköping": "linkoping",
};

export function resolveCity(rawSlug) {
  if (!rawSlug) return null;
  const decoded = decodeURIComponent(rawSlug).toLowerCase().trim();
  const direct = CITIES[decoded];
  if (direct) return { ...direct, isFallback: false };
  const aliased = SLUG_ALIASES[decoded] && CITIES[SLUG_ALIASES[decoded]];
  if (aliased) return { ...aliased, isFallback: false };

  // Fallback: pretty-cap the slug and use generic content
  const name = prettyCapitalize(decoded);
  return {
    slug: decoded.replace(/[^a-z0-9-]/g, ""),
    name: name || "Din stad",
    region: "Sverige",
    blurb: `Hundverksamheter i ${name || "din stad"} förtjänar ett modernt affärssystem som faktiskt förstår hur svenska hunddagis, pensionat och hundvakter jobbar i vardagen.`,
    activeBusinesses: "Växande",
    neighborhoods: [],
    testimonial: {
      name: "Sofia Karlsson",
      role: "Ägare",
      business: `Lokal Hundverksamhet`,
      area: name || "Sverige",
      quote: `Vi driver hunddagis i ${name || "vår stad"} och letade länge efter ett affärssystem som faktiskt är byggt för svenska förhållanden. Hundify är det enda som har levt upp till löftet.`,
      rating: 5,
      initial: "S",
    },
    isFallback: true,
  };
}
